
export default {
    name: "CardSkeleton",
    props: {
        width: {
            type: String,
            default: "330",
        },
        height: {
            type: String,
            default: "550px",
        },
        size: {
            type: Number,
            default: 1,
        },
        wrap: {
            type: Boolean,
            default: false,
        },
        isPost: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        computedSize() {
            if (this.wrap) {
                return 1
            }
            return this.size
        },
    },
}
